import React from "react";

export const Copyright = () => (
    <div><b>OrchestraManager</b> &copy; 2017-{new Date().getFullYear()}</div>
);